export default __webpack_public_path__ + "static/media/BANBERRY.9a3abf4b.jpeg";